/**
 * Encode a string as standard base64 (same alphabet and padding as
 * `Buffer.from(value).toString('base64')`): the value is serialized to UTF-8
 * bytes first, so any unicode content is supported.
 */
export function encodeBase64(value: string): string {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  // fromCharCode via spread overflows the call stack on large inputs
  const CHUNK_SIZE = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK_SIZE) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK_SIZE));
  }
  return btoa(binary);
}
